module.exports = __webpack_public_path__ + "images/kadlec-white.png";


//////////////////
// WEBPACK FOOTER
// ./assets/kadlec-white.png
// module id = 6
// module chunks = 0